import React from 'react'
import {
    StyledHeadline,
    StyledHeadlineText,
    StyledFeatureLabel,
} from './FeatureHeadline.styled'
import { Classification } from '@news-mono/web-common'
import { useFeature } from '@news-mono/web-common'
import { getFeatureEditorialType } from '../../templates/Publication/lib/get-editorial-type'
import { EditorialLabel } from '../../typography/EditorialLabel/EditorialLabel'

export interface FeatureHeadlineProps {
    text: string
    classification?: Classification
}

export const FeatureHeadline: React.FC<FeatureHeadlineProps> = ({
    text,
    classification,
}) => {
    const storyClassification = useFeature('story-classification')
    const editorialType = getFeatureEditorialType(
        classification,
        storyClassification,
    )

    return (
        <StyledHeadline itemProp="headline" hasEditorialType={!!editorialType}>
            {editorialType && (
                <StyledFeatureLabel>
                    <EditorialLabel type={editorialType} isLarge />
                </StyledFeatureLabel>
            )}
            <StyledHeadlineText>{text}</StyledHeadlineText>
        </StyledHeadline>
    )
}
